import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/img/img_work_step_1_bg.jpg'
import _imports_1 from '../assets/img/img_work_step_2_bg.jpg'
import _imports_2 from '../assets/img/img_work_step_3_bg.jpg'


const _hoisted_1 = { class: "px-20px group relative <sm:pt-5/8" }
const _hoisted_2 = { class: "inline-flex items-center" }
const _hoisted_3 = { class: "w-full flex flex-col ml-15px justify-between" }
const _hoisted_4 = { class: "uppercase font-600 text-24px <lg:text-16px <sm:text-14px" }
const _hoisted_5 = { class: "text-22px <lg:text-14px <sm:text-12px leading-26px" }
const _hoisted_6 = {
  key: 0,
  src: _imports_0,
  class: "bg-image abs-horiz-center"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_1,
  class: "bg-image abs-horiz-center"
}
const _hoisted_8 = {
  key: 2,
  src: _imports_2,
  class: "bg-image abs-horiz-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["w-full flex justify-around items-center px-36px <lg:px-25px z-6 relative py-13px bg-white border border-5px", {
        'border-hex-6664D6': _ctx.active,
        'border-transparent': !_ctx.active,
      }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(["font-600 flex-none text-130px text-hex-515151 <lg:text-64px <sm:text-64px", { 'violet-text-gradient': _ctx.active }])
        }, _toDisplayString(_ctx.num), 3),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.title), 1),
          _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
          ])
        ])
      ])
    ], 2),
    (_ctx.num === 1)
      ? (_openBlock(), _createElementBlock("img", _hoisted_6))
      : _createCommentVNode("", true),
    (_ctx.num === 2)
      ? (_openBlock(), _createElementBlock("img", _hoisted_7))
      : _createCommentVNode("", true),
    (_ctx.num === 3)
      ? (_openBlock(), _createElementBlock("img", _hoisted_8))
      : _createCommentVNode("", true)
  ]))
}